export default class SettingsLocks {
    constructor (json) {

        this.webTimeout = false;
        this.threshold = false;
        this.interval = false;
        this.maximumAge = false;
        this.minimumLength = false;
        this.alphabeticalCharacters = false;
        this.uppercaseCharacters = false;
        this.lowercaseCharacters = false;
        this.numericCharacters = false;
        this.punctuationOrOtherCharacters = false;

        if (json)
            mapJsonToSettingsLocks(json, this);
    }

    createCopy () {
        const settingsLocks = new SettingsLocks();
        settingsLocks.threshold = this.threshold;
        settingsLocks.webTimeout = this.webTimeout;
        settingsLocks.interval = this.interval;
        settingsLocks.maximumAge = this.maximumAge;
        settingsLocks.minimumLength = this.minimumLength;
        settingsLocks.alphabeticalCharacters = this.alphabeticalCharacters;
        settingsLocks.uppercaseCharacters = this.uppercaseCharacters;
        settingsLocks.lowercaseCharacters = this.lowercaseCharacters;
        settingsLocks.numericCharacters = this.numericCharacters;
        settingsLocks.punctuationOrOtherCharacters = this.punctuationOrOtherCharacters;

        return settingsLocks;
    }
}

const mapJsonToSettingsLocks = (json, settingLocks) => {
    if (json) {
        settingLocks.webTimeout = json.WebTimeout;
        settingLocks.threshold = json.LockoutMaxBadPasswordAttempts;
        settingLocks.interval = json.LockoutIntervalMinutes;
        settingLocks.maximumAge = json.PasswordValidDays;
        settingLocks.minimumLength = json.MinimumPasswordLength;
        settingLocks.alphabeticalCharacters = json.RequiredAlphabeticalLetters;
        settingLocks.uppercaseCharacters = json.RequiredCapitalLetters;
        settingLocks.lowercaseCharacters = json.RequiredLowercaseLetters;
        settingLocks.numericCharacters = json.RequiredNumerals;
        settingLocks.punctuationOrOtherCharacters = json.RequiredPunctuationOrOther;
    }
    else {
        settingLocks = undefined;
    }
};
